<template>
  <div
    v-if="display"
    class="log-file-container"
    width="1000"
  >
    <v-card class="log-component">
      <v-card-title class="text-h5 grey lighten-2">
        Device Logs: {{ device.vehicle_name }}
      </v-card-title>
      <v-icon class="close-icon" large color="red" @click="closeWindow">mdi-close</v-icon>
      <br>
      <v-container>
        <v-row>
          <v-col cols="4">
            <material-date-time-range 
              :start-value="startValue" 
              :local-time="true"
              @change="range => selectDateRange = range">
            </material-date-time-range>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12">
            <div class="text-center">
              <v-data-table
                :items="logFiles"
                :headers="headers"
                item-key="created"
                :loading="loading"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template v-slot:item.created="{ item }">
                  {{ formattedDate(item.created) }}
                </template>
                
                <template v-slot:item.download_file="{ item }">
                  <RetrieveFileStateManager 
                    :item="device"
                    :log="item"
                    :org="org"
                  />
                </template>
              </v-data-table>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <br>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          :disabled="loading"
          @click="getFiles"
        >
          Submit
        </v-btn>
      </v-card-actions>
      <v-row v-if="errors">
        <v-col cols="12">
          <div class="err-msg">{{ errors }}</div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>

// import { Logger } from "aws-amplify";
// const logger = new Logger("Download Log Comp");

import RetrieveFileStateManager from './RetrieveFileStateManager.vue';

import moment from "moment";

import { ListAllFiles } from "@/services/file-retrieval.js"

export default {
  name: 'DownloadLog',
  components: {
    RetrieveFileStateManager
  },
  props: {
    device: {
      type: Object,
      required: true
    },
    org: {
      type: String,
      required: true
    },
    display: {
      type: Boolean,
      required: true
    },
    isDefaultDevice: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      selectDateRange: [
        moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss")
      ],
      loading: false,
      fileRequestLoading: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Created',
          value: 'created',
          align: 'left'
        },
        {
          text: 'Download File',
          value: 'download_file',
          align: 'center'
        },
      ],
      sortBy: 'created',
      sortDesc: true,
      orgID: '',
      logFiles: [],
      startValue: [
        moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss")
      ],
      errors: null
    }
  },
  watch: {
    display(val) {
      this.dialog = val;
      this.$emit('toggleLogComp', val)
    }
  },
  methods: {
    formattedDate(date) {
      let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");

      return moment(formattedDate).isValid() ? formattedDate : date;
    },
    closeWindow() {
      this.logFiles = [];
      this.errors = null;
      this.$emit('closeLogComp');
    },
    emitDates() {
      let payload = {
        range: this.selectDateRange,
        item: this.device
      }
      this.$emit('dateRangeSet', payload);
    },
    async getFiles() {
      this.loading = true;
      let device = null;
      let vehicleId = null;

      // Get device ID
      if(this.device.devices && this.device.devices.length > 0) {
        let defaultDevice = null;

        defaultDevice = this.device.devices.find(device => {
            return device.is_defaultdevice == true || device.is_default_device == true || device.is_default_device === "true" || device.is_default == 'True';
        });

        if (defaultDevice) {
          device = defaultDevice;
          vehicleId = this.device.id;

        }
      } else if (this.device.hasOwnProperty('is_default')) {
        device = this.device;
        vehicleId = device.vehicle_id;
      }
      
      
      if (device) {
        var fileList = await ListAllFiles(this.org, vehicleId, device.device_id, this.selectDateRange, 'log');

        try {
          this.logFiles = fileList.Files;
          this.loading = false;
        }
        catch (err) {
          this.errors = err;
          this.loading = false;
        }
      }
      else {
        this.loading = false;
        this.errors = 'Missing Device ID';
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .log-file-container {
    z-index: 9998;
    position: fixed;
    left: 0%;
    right: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.4) !important;
    width: 100vw;
    height: 100vh;
    .log-component {
      background: white;
      margin: 0;
      position: relative;
      top: 50%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      padding: 0;
      overflow: hidden;
      border: solid grey 2px;
      width: 1000px;
    }
    .close-icon {
      top: 0;
      right: 0;
      position: absolute;
    }
    .err-msg {
      color: #f55a4e;
      text-align: center;
      padding-bottom: .5em;
    }
  }
  .download-log {
    &:hover {
      cursor: pointer;
    }
  }
</style>